import axios from 'axios'
import type { fwtype, pagination } from '../types/types'

const baseurl = `${import.meta.env.VITE_APP_PROTOCOL}://${import.meta.env.VITE_API_HOST}:${import.meta.env.VITE_API_PORT}/${import.meta.env.VITE_API_SUBPATH}`
const url = 'fwtype'

export const readFwtypeListAPI = async (pagenation: pagination): Promise<fwtype[]> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'list',
      ...pagenation
    }
  })
  console.log("readFwtypeListAPI 응답:", response.data)
  return response.data.data

}

export const addFwtypeAPI = async (fwtypename: string): Promise<number> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'add',
      name: fwtypename,
    }
  })
  console.log("addFwtypeAPI 응답:", response.data)
  return response.data
}

export const updateFwtypeAPI = async (fwtype: fwtype): Promise<boolean> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'update',
      ...fwtype
    }
  })
  console.log("updateFwtypeAPI 응답:", response.data)
  return response.data
}

export const deleteFwtypeAPI = async (id: number): Promise<boolean> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'delete',
      id: id,
    }
  })
  console.log("deleteFwtypeAPI 응답:", response.data)
  return response.data
}

export const paginationFwtypeAPI = async (size: number): Promise<number> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'pagination',
      size: size,
    }
  })
  console.log("paginationFwtypeAPI 응답:", response.data)
  return response.data.data.totalpage
}